import { render } from "./TableUser.vue?vue&type=template&id=c24f1c96"
import script from "./TableUser.vue?vue&type=script&lang=js"
export * from "./TableUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__